import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Button } from 'element-react'
import { MainSectionDefault } from '../../views/includes/Wrappers'
import AppRoutes from '../../../routes/appRoutes'

const FormMessage = props => {
    const {
        buttonLabel = 'Return to Dashboard',
        buttonLink = AppRoutes.home(),
        messageContent,
        messageTitle,
    } = props
    return (
        <MainSectionDefault>
            <img
                className="center success-checkmark"
                src="/img/success_checkmark.svg"
            />
            <h4 className="text-center margin-bottom-small">{messageTitle}</h4>
            <p className="text-center margin-bottom-medium">{messageContent}</p>
            <Link to={buttonLink}>
                <Button type="default" className="center">
                    {buttonLabel}
                </Button>
            </Link>
        </MainSectionDefault>
    )
}

FormMessage.propTypes = {
    buttonLabel: PropTypes.string,
    buttonLink: PropTypes.string,
    messageContent: PropTypes.string.isRequired,
    messageTitle: PropTypes.string.isRequired,
}

export default FormMessage
